
import { useState } from 'react';
import { MessageProps } from "../../../typings/messages";
import { MemberMediaProps } from "../../../typings/memberMedia";
import GalleryLightBox from '../../../components/GalleryLightBox';

export interface MessageTextProps {
    message: MessageProps;
    position: string;
    renderTicks: any;
}

const MessageProfileImages = ({ message, position, renderTicks }: MessageTextProps) => {
    const images: any = message.image;
    const [LightBoxIsOpen, setLightBoxIsOpen] = useState(false);
    const [messageIndex, setMessageIndex] = useState<number>(0);

    const handleImageClick = (key: any) => {
        setLightBoxIsOpen(true);
        setMessageIndex(key);
    }


    return (
        <>
            <div className={position === "left" ? "talk_group flip" : "talk_group w-clearfix"}>
                <div className={position === "left" ? "buble flip" : "buble"}>

                    {/* <img src="/images/buble_cut.svg" loading="lazy" alt="" className="buble_cut" /> */}
                    <div className="sm_picts_content">

                        {images.map((uri: any, key: any) => (

                            <div key={key} style={{ cursor: 'pointer' }} onClick={() => handleImageClick(key)} className={"buble_sm_pict"}>
                                <img src={uri} loading="lazy" alt="" />
                            </div>

                        ))}
                    </div>
                </div>
                {renderTicks()}
            </div>

            {LightBoxIsOpen && (
                <GalleryLightBox
                    imagePage={messageIndex}
                    isOpen={LightBoxIsOpen}
                    images={images}
                    mediaLength={images?.length}
                    onClose={() => setLightBoxIsOpen(false)}
                />
            )}
        </>
    )
}

export default MessageProfileImages;